import React from 'react';
import { PackageIcon } from 'lucide-react';
export const genreColors: Record<string, string> = {
  Fantasy: '#6366f1',
  Romance: '#ec4899',
  Mystery: '#7c3aed',
  Thriller: '#dc2626',
  Horror: '#1f2937',
  'Sci-Fi': '#2563eb',
  Adventure: '#16a34a',
  Historical: '#b45309',
  'Young Adult': '#0891b2',
  Contemporary: '#0d9488',
  default: '#4b5563'
};
export const statusColors: Record<string, string> = {
  active: 'bg-green-500',
  retired: 'bg-gray-500',
  'one-time': 'bg-amber-500'
};
export const statusLabels: Record<string, string> = {
  active: 'Active',
  retired: 'Retired',
  'one-time': 'Limited'
};